module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('h1', {
    staticClass: "Prelims-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Once upon a time, Andrew Ridgway, who was born in 1973, wanted to be a writer. But life had other ideas, and so for over 21 years he has worked as a theatre nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("In his first published book, which collects together his humanistic themed poetry, Andrew is processing difficult events in his life. These include recent experiences being re-deployed to his hospital’s intensive care unit during the Covid 19 pandemic.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("He is currently working on a second book of poetry based on love and relationships.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323284cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB.vue
// module id = 57
// module chunks = 0